// Ajitesh : 10/11/2023: BT-109135: Breeze eDIS implementation - Start
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BzInputText, BzMasterAgGrid, BzToastMessage } from "../components";
import { toastConfig } from "../redux/actions/toast";
import { EDIS_PERMISSION_MESSAGE, EDIS_SEARCH_ID, EXCHANGE_TYPES, EDIS_MODES } from "../utils/global_variables";
import { _executeEdisOnline } from "../controllers";
import { Container, Row, Col } from "react-bootstrap";
import { updateEdisIsLoading } from "../redux/actions/edis";
import { handleModal } from "../redux/actions/modals";
import GridHeaderSearch from "./GridHeaderSearch";

const EdisAuthScrips = (props) => {
    const {
        scripDetailsForGrid,
        singleScripOrderData,
        orderCartScripsForEdis,
        edisConfig,
        exchgAndMktSegData,
        productType,
        isAmo,
        multiIsinEnabled,
        mode,
        refreshEdisDataAfterFlow,
        edisURL,
        showOrderConfirmModal,
        orderData
    } = props;
    const dispatch = useDispatch();
    const userDPDetails = useSelector(state => state.auth.dpDetails);
    const [settlementType, setSettlementType] = useState("T+1 (Next Day)");
    const edisTableRef = useRef();
    const [rowData, setRowData] = useState([]);

    const summaryDetailsForEdis = (edisScrips) => {
        let edisScripSummaryArr = edisScrips.filter(scrip => scrip.nSettlementType === settlementType);
        let dpDetailsEdis = null;
        let dataPayloadEdis = null;
        if (orderCartScripsForEdis.length > 0 && mode === EDIS_MODES.EDIS_MODE_ORDERCART) {
            dpDetailsEdis = {
                ...userDPDetails.data
            };
        }
        // Condition for single order SELL and into edis flow
        else if (edisScrips.length === 1 && mode === EDIS_MODES.EDIS_MODE_SINGLE_ORDER) {
            dpDetailsEdis = {
                ...userDPDetails.data,
                "ISIN": edisScrips[0].sISINCode || "",
                "edisRequestQty": edisScrips[0].eDISRequestQty,
                "securityDescription": edisScrips[0].sSecurityDesc || ''
            };
        }
        else {
            dpDetailsEdis = {
                ...userDPDetails.data,
                "ISIN": "",
                "securityDescription": ""
            };
        }
        if (edisScripSummaryArr.length > 0) {
            dataPayloadEdis = {
                dpDetails: { ...dpDetailsEdis },
                exchangeName: exchgAndMktSegData.exchangeName,
                instrumentType: EXCHANGE_TYPES.CONST_EQUITY,
                marketSegmentId: exchgAndMktSegData.marketSegmentId,
                scripsData: [...edisScripSummaryArr],
                productType: productType,
                isAmo: isAmo,
                selectedSettlement: settlementType === "T+1 (Next Day)" ? 1 : 2,
                isMultiIsin: multiIsinEnabled,
                edisURL: edisURL
            };
        }
        return dataPayloadEdis;
    };

    useEffect(() => {
        // Setting row data for grid based on scripDetailsForGrid prop
        const rowDetails = scripDetailsForGrid.map(scrip => {
            return {
                sSecurityDesc: scrip.sSecurityDesc,
                authorizedQty: {
                    ApprovedQuantity: scrip.ApprovedQuantity,
                    eDISDPQty: scrip.eDISDPQty
                },
                eDISRequestQty: scrip.eDISRequestQty,
                nSettlementType: "T+1 (Next Day)",
                ApprovedQuantity: scrip.ApprovedQuantity,
                eDISDPQty: scrip.eDISDPQty,
                TodayFreeQty: scrip.TodayFreeQty,
                ClosePrice: scrip.ClosePrice,
                sISINCode: scrip.sISINCode,
                //eDISRequestQty: scrip.eDISRequestQty,
                eDISCheckQty: scrip.eDISCheckQty,
            };
        });
        setRowData(rowDetails);
    }, [scripDetailsForGrid]);

    // Ajitesh - 22/03/2024 Cleanup effect to remove edis auth toast message when user navigates away to different scrren
    useEffect(() => {
        return () => {
            dispatch(toastConfig({ show: false }));
        };
    }, [dispatch]);

    const validationForEdis = (event) => {
        let errorMsg = "";
        let isValid = true;
        const numOfSelectedRows = edisTableRef.current.api.getSelectedRows().length;
        const selectedRowsForEdis = edisTableRef.current.api.getSelectedRows();
        let totalRequestValue = 0;
        for (let i = 0; i < numOfSelectedRows; i++) {
            totalRequestValue += parseInt((selectedRowsForEdis[i].ClosePrice * parseInt(selectedRowsForEdis[i].eDISRequestQty)).toFixed(2));
            if (selectedRowsForEdis[i].eDISRequestQty > (selectedRowsForEdis[i].totalFreeQty - selectedRowsForEdis[i].todayFreeQty - selectedRowsForEdis[i].approvedQty)) {
                isValid = false;
                errorMsg += "eDIS quantity should be less than equal to DP quantity\n";
            }
        }
        if (edisConfig.MaxTranCount <= edisConfig.UserTranCount) {
            isValid = false;
            errorMsg += "Number of transactions limit reached.\n";
        }
        if (totalRequestValue > edisConfig.Singletrans) {
            isValid = false;
            errorMsg += "Single transaction limit reached.\n";
        }
        if (totalRequestValue > (edisConfig.PerDayTransactionvalue - edisConfig.ValueUtilized)) {
            isValid = false;
            errorMsg += "Daily transaction limit reached.\n";
        }
        if (mode === EDIS_MODES.EDIS_MODE_SINGLE_ORDER && (event.data.eDISRequestQty + (orderData?.pendingQuantity || 0) + event.data.ApprovedQuantity + event.data.TodayFreeQty) < singleScripOrderData.scripQuantity) {
            isValid = false;
            errorMsg += "eDIS quantity cannot be less than order quantity.\n";
        }
        if (isValid === false) {
            dispatch(toastConfig({
                autoDismiss: false,
                show: true,
                message: <div className='pre-wrap'>{errorMsg}</div>,
                button: [
                    {
                        btnName: "OK",
                        type: "OK",
                        className: 'btn btn-solid ms-3',
                        onClickHandler: () => {
                            dispatch(toastConfig({ show: false }));
                            // Ajitesh 12/06/2024 - Below block is used to (re)select nodes after validation toast message is dismissed
                            const savedSelectedNodeIds = edisTableRef.current.api.getSelectedNodes().map(node => node.id);
                            savedSelectedNodeIds.forEach(nodeId => {
                                const node = edisTableRef.current.api.getRowNode(nodeId);
                                if (node) {
                                    node.setSelected(true);
                                    onRowSelected({ ...edisTableRef.current, data: node?.data, node: node });
                                }
                            });
                            // Ajitesh 12/06/2024 - Below block is used to (re)select nodes after validation toast message is dismissed
                        }
                    }
                ]
            }));
        }
        return isValid;
    };

    const onRowSelected = (event) => {
        // Ajitesh 17-04-2024 edis- Don't allow scrip that is being sold from order entry modal to be deselected
        if (mode === EDIS_MODES.EDIS_MODE_SINGLE_ORDER) {
            if (singleScripOrderData.sISINCode === event.data.sISINCode) {
                event.node.setSelected(true);
            }
        }
        // Ajitesh 17-04-2024 edis- we only show those scrips in modal which are there in cart so force all rows to be selected
        if (mode === EDIS_MODES.EDIS_MODE_ORDERCART) {
            event.node.setSelected(true);
        }
        const dataPayload = summaryDetailsForEdis(event.api.getSelectedRows());
        // Refresh cells so custom components in grid can be updated and get updated data like if node is selected
        event.api.refreshCells({ force: true });
        if (edisTableRef.current && event.api.getSelectedNodes().length > 0) {
            dispatch(toastConfig({
                autoDismiss: false,
                show: true,
                message: EDIS_PERMISSION_MESSAGE.replace("{0}", edisTableRef.current.api.getSelectedRows().length),
                button: [{
                    btnName: "Authorize",
                    type: "AUTHORIZE_SCRIPS_FOR_EDIS",
                    className: 'btn btn-solid ms-3',
                    onClickHandler: () => {
                        //console.log("dataPayload", dataPayload);
                        let edisValidFlag = validationForEdis(event);
                        // Call controller function to generate URL here
                        if (edisValidFlag) {
                            dispatch(updateEdisIsLoading(true));
                            dispatch(toastConfig({ show: false }));
                            // Ajitesh: 15/03/2024 eDIS new flow as per aero
                            _executeEdisOnline(dataPayload).then((response) => {
                                refreshEdisDataAfterFlow();
                                dispatch(handleModal([{ "EDIS_PERMISSION_MODAL_SINGLE_ORDER": false }, { "EDIS_PERMISSION_MODAL_ORDER_CART": false }], true));
                                dispatch(updateEdisIsLoading(false));
                                if (mode === EDIS_MODES.EDIS_MODE_SINGLE_ORDER && singleScripOrderData.sISINCode === event.data.sISINCode) {   // Deepti B. if user placed sell AMO order for scrip where all DPQty is authorized, selecting different scrip from edis grid and proceed with authorization then Should not direct to order confirmation page
                                    showOrderConfirmModal();
                                }
                                //handleResponseForAmoSell(response); // Ajitesh 13-06-2024 Not needed anymore as amo order response handling done directly from single order screen. Keep until testing complete
                            }).catch((error) => {
                                dispatch(updateEdisIsLoading(false));
                                dispatch(toastConfig({
                                    autoDismiss: false,
                                    show: true,
                                    message: <div>EDIS Transaction failed.</div>,
                                    button: [
                                        {
                                            btnName: "OK",
                                            type: "OK",
                                            className: 'btn btn-solid ms-3',
                                            onClickHandler: () => {
                                                // Ajitesh 12/06/2024 - Below block is used to (re)select nodes after validation toast message is dismissed
                                                const savedSelectedNodeIds = edisTableRef.current.api.getSelectedNodes().map(node => node.id);
                                                savedSelectedNodeIds.forEach(nodeId => {
                                                    const node = edisTableRef.current.api.getRowNode(nodeId);
                                                    if (node) {
                                                        node.setSelected(true);
                                                        onRowSelected({ ...edisTableRef.current, data: node?.data, node: node });
                                                    }
                                                });
                                                // Ajitesh 12/06/2024 - Below block is used to (re)select nodes after validation toast message is dismissed
                                            }
                                        }
                                    ]
                                }));
                                refreshEdisDataAfterFlow();
                                console.log("error in promise", error);
                            });
                        }
                    }
                }]
            }));
        }
        else {
            dispatch(toastConfig({ show: false }));
        }
    };

    const onRowDataUpdated = () => {
        if (edisTableRef.current) {
            edisTableRef.current.api.sizeColumnsToFit();
            // Select all nodes when coming from hamburger menu
            if (mode === EDIS_MODES.EDIS_MODE_HAMBURGER || mode === EDIS_MODES.EDIS_MODE_PORTFOLIO || mode === EDIS_MODES.EDIS_MODE_ORDERCART) {
                edisTableRef.current.api.sizeColumnsToFit();
                edisTableRef.current.api.selectAll();
            }
            else if (mode === EDIS_MODES.EDIS_MODE_SINGLE_ORDER && singleScripOrderData) {
                edisTableRef.current.api.forEachNode((node) => {
                    if (node.data.sISINCode === singleScripOrderData.sISINCode) {
                        node.setSelected(true);
                    }
                });
            }
            else { }
        }
    };

    const onChangeGridHeaderSearch = useCallback(() => {
        edisTableRef.current.api.setQuickFilter(
            document.getElementById('edis_scrips_header_search').value
        );
    }, []);

    const SampleCellRenderer = (props) => {
        const handleRequestQtyChange = (e) => {
            // Number(e.target.value) !== 0 && Number(e.target.value) <= Number(props.data.authorizedQty.eDISDPQty) - Number(props.data.authorizedQty.ApprovedQuantity) ? props.setValue(Number(e.target.value)) : props.setValue(props.data.eDISRequestQty);
            if(userDPDetails?.data?.sDepository===DEPOSITORY_NSDL){
                props.setValue(Number(e.target.value))
            }else{}
        };

        const handlePlusMinusBtnClick = (action) => {
            switch (action) {
                case "add": {
                    if (Number(props.getValue()) < (Number(props.data.authorizedQty.eDISDPQty) - Number(props.data.authorizedQty.ApprovedQuantity))) {
                        props.setValue((Number(props.getValue()) + 1));
                    }
                    break;
                }
                case "sub": {
                    if (Number(props.getValue()) > 1) {
                        props.setValue((Number(props.getValue()) - 1));
                    }
                    break;
                }
                default:
                    break;
            }
        };

        const onQuantityInputsKeyDown = (e) => {
            if (e.which === 38 || e.which === 40) {
                e.preventDefault();
                if (e.which === 38) {
                    handlePlusMinusBtnClick("add");
                } else if (e.which === 40) {
                    handlePlusMinusBtnClick("sub");
                } else { }
            }
        };
        const checkIsSelected = (props)=>{
            if(props?.api?.getSelectedRows()?.length){
               return props?.api?.getSelectedRows()?.some((each)=>each?.sISINCode===props?.data?.sISINCode)
            }
        }
        return (
            // Sumit G - 21-12-23
            <Container fluid className='p-0'>
                <Row className='g-0 justify-content-center align-items-center py-1'>
                    <Col md={6}>
                        <div className={`input-group postion-relative ${!checkIsSelected(props) ? `disabled` : null}`}>
                            <div className='icon-12 icon-order-decrease input-number-left-wrap' onClick={() => { if (checkIsSelected(props)) { handlePlusMinusBtnClick("sub"); } }}></div>
                            <BzInputText size='sm' type="text" className='text-center' name="firstLeg" onChange={(e) => handleRequestQtyChange(e)} value={props.getValue()} disabled={!checkIsSelected(props)} onKeyDown={onQuantityInputsKeyDown} />
                            <div className='icon-12 icon-order-increase input-number-right-wrap' onClick={() => { if (checkIsSelected(props)) { handlePlusMinusBtnClick("add"); } }}></div>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    };

    const getIsRowSelectedForSingleScripOrOrderCart = (params) => {
        if(mode === EDIS_MODES.EDIS_MODE_HAMBURGER || mode === EDIS_MODES.EDIS_MODE_PORTFOLIO) {
            return true;
        }
        if (singleScripOrderData) {
            return params.data.sISINCode.includes(singleScripOrderData.sISINCode) ? true : false;
        }
        // Ajitesh - 22/03/2024 Make checkboxes disabled for all scrips in order cart
        if (orderCartScripsForEdis.length) {
            orderCartScripsForEdis.forEach(scrip => {
                return params.data.sISINCode.includes(scrip.sISINCode) ? true : false;
            });
        }
    }

    const rowSelection = useMemo(() => {
        return {
            mode: 'multiRow',
            isRowSelectable: params => getIsRowSelectedForSingleScripOrOrderCart(params)
        };
    }, [mode, orderCartScripsForEdis, singleScripOrderData]);

    const columnDefs = useMemo(() => [
        {
            colId: "check",
            headerCheckboxSelection: true,
            showDisabledCheckboxes: true,
            maxWidth: 40,
            resizable: false,
            suppressMenu: true,
            sortable: false,
            suppressMovable: true,
            suppressNavigable: true,
            hide: true,
        },
        {
            field: "sSecurityDesc",
            headerComponent: GridHeaderSearch,
            resizable: false,
            suppressMenu: true,
            headerComponentParams: { onChangeGridHeaderSearch, gridRef: edisTableRef, component: 'edis', id: EDIS_SEARCH_ID },
            suppressMovable: true,
            suppressNavigable: true,
        },
        {
            field: "authorizedQty",
            headerName: "AUTHORIZED QUANTITY",
            cellRenderer: (params) => <p>{params.data.authorizedQty.ApprovedQuantity} of {params.data.authorizedQty.eDISDPQty}</p>,
            suppressMovable: true,
            suppressNavigable: true,
            resizable: false,
            suppressMenu: true,
        },
        {
            field: "eDISRequestQty",
            headerName: "REQUEST QUANTITY",
            cellRenderer: SampleCellRenderer,
            resizable: false,
            suppressMenu: true,
            suppressMovable: true,
            suppressNavigable: true,
        },
        {
            field: "nSettlementType",
            headerName: "SETTLEMENT",
            resizable: false,
            suppressMenu: true,
            suppressMovable: true,
            suppressNavigable: true,
        },
    ], [scripDetailsForGrid]);

    return (
        <>
            {window.location.pathname==="/edis"?<BzToastMessage />:null}
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col>
                        <div>
                            <BzMasterAgGrid
                                arrColumnData={columnDefs}
                                arrRowData={rowData}
                                rowSelection={rowSelection}
                                ref={edisTableRef}
                                className='ag-theme-alpine edis-ag-grid-wrapper'
                                onRowDataUpdated={onRowDataUpdated}
                                onRowSelected={onRowSelected}
                                isCompress={true}
                                defaultColProps={{ flex: 1 }}
                                isFirstRowSelected={false}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );



};

export default memo(EdisAuthScrips);
// Ajitesh : 10/11/2023: BT-109135: Breeze eDIS implementation - End